import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import $ from "jquery";
import ProcessDiscoverySideBar from "./ProcessDiscoverySideBar";
import { Row, Col, Card, Space, Table, Tag, Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import userIcon from "../../../../../images/icons-dashborad/users.svg";
import clockIcon from "../../../../../images/icons-dashborad/clock.svg";
import copyIcon from "../../../../../images/icons-dashborad/copy.svg";

import { Bar, Pie } from "react-chartjs-2";
import { ArcElement } from "chart.js";
import { Chart } from "chart.js";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ProcessAction from "./ProcessAction";
import { getMetrics } from "../../../../../redux/actions/skill";
import Loader from "../../../../../components/loader";
import EmptyLoader from "../../../../../components/emptyLoader";
import unauthorizedIcon from "../../../../../images/403-Error-pana.png";

Chart.register(ArcElement);

const ViewChartProcessDiscovery = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const skillID = params?.id;
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrganization
  );
  const metrics = useSelector((state) => state?.skillReducer?.rpdMetric);
  const isLoadingMetrics = useSelector(
    (state) => state?.skillReducer?.isLoadingMetrics
  );
  useEffect(() => {
    if (skillID && userRole?.role_id == "2") {
      dispatch(getMetrics(skillID));
    }
  }, []);
  // useEffect(() => {
  //   $(".sidebar-global").hide();
  //   $(".process-sidebar").show();
  //   return () => {
  //     $(".sidebar-global").show();
  //     $(".process-sidebar").hide();
  //   };
  // }, []);

  const chartOptionsLabelTime = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top", // 'top', 'left', 'bottom', 'right'
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `Average Process Time: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
          color: "rgba(255, 99, 132, 0.2)",
        },
        ticks: {
          callback: (value) => `${value}`,
        },
      },
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
    },
  };
  const chartOptionsLabel = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top", // 'top', 'left', 'bottom', 'right'
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `Total Count: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
          color: "rgba(255, 99, 132, 0.2)",
        },
        ticks: {
          callback: (value) => `${value}`,
        },
      },
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
    },
  };
  const chartOptionsEmail = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top", // 'top', 'left', 'bottom', 'right'
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `Variants Created: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
          color: "rgba(255, 99, 132, 0.2)",
        },
        ticks: {
          callback: (value) => `${value}`,
        },
      },
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
    },
  };

  const chartOptionsMetaData = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top", // 'top', 'left', 'bottom', 'right'
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `Final Status: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
          color: "rgba(255, 99, 132, 0.2)",
        },
        ticks: {
          callback: (value) => `${value}`,
        },
      },
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
    },
  };

  return (
    <>
      {/* <ProcessDiscoverySideBar /> */}

      {isLoadingMetrics ? (
        <Loader />
      ) : (
        <React.Fragment>
          {!Object.entries(metrics)?.length ? (
            <>
              {" "}
              <EmptyLoader
                message="Not enough data to show analytics"
                styles={{ width: "80px", margin: "auto" }}
                root={{ display: "flex" }}
              />
            </>
          ) : (
            <>
              {userRole?.role_id == "2" ? (
                <>
                  <div className="compare-page">
                    <ProcessAction {...metrics?.skillInfo} />
                    <div className="pc-block pc-dashboard scrollable">
                      <Row gutter={16} className="row-stats">
                        <Col className="gutter-row" span={8}>
                          <Card className="dash-stats">
                            <div
                              className="card-icon"
                              style={{ backgroundColor: "#FEF3E2" }}
                            >
                              <img src={userIcon} alt="" />
                            </div>
                            <div className="card-text">
                              <h2>{metrics?.totalParticipantCount}</h2>
                              <span>No. of Participants</span>
                            </div>
                          </Card>
                        </Col>
                        <Col className="gutter-row" span={8}>
                          <Card className="dash-stats">
                            <div
                              className="card-icon"
                              style={{ backgroundColor: "#FFEFEF" }}
                            >
                              <img src={copyIcon} alt="" />
                            </div>
                            <div className="card-text">
                              <h2>{metrics?.totalVariants}</h2>
                              <span>No. of Variants</span>
                            </div>
                          </Card>
                        </Col>
                        <Col className="gutter-row" span={8}>
                          <Card className="dash-stats">
                            <div
                              className="card-icon"
                              style={{ backgroundColor: "#E1F0DA" }}
                            >
                              <img src={clockIcon} alt="" />
                            </div>
                            <div className="card-text">
                              <h2>{metrics?.avgProcessCycle} minutes</h2>
                              <span>Average Process Time</span>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                      <Row gutter={16} className="row-charts">
                        <Col className="gutter-row" span="24">
                          <Card className="dash-stats">
                            <Bar
                              options={chartOptionsLabel}
                              data={metrics?.labelChartData}
                            />
                          </Card>
                        </Col>
                      </Row>
                      <Row gutter={16} className="row-charts">
                        <Col className="gutter-row" span="24">
                          <Card className="dash-stats">
                            <Bar
                              options={chartOptionsEmail}
                              data={metrics?.emailChartData}
                            />
                          </Card>
                        </Col>
                      </Row>
                      <Row gutter={16} className="row-charts">
                        <Col className="gutter-row" span="24">
                          <Card className="dash-stats">
                            <Bar
                              options={chartOptionsLabelTime}
                              data={metrics?.labelAvgTimeChartData}
                            />
                          </Card>
                        </Col>
                      </Row>
                      <Row gutter={16} className="row-charts">
                        <Col className="gutter-row" span="24">
                          <Card className="dash-stats">
                            <Bar
                              options={chartOptionsMetaData}
                              data={metrics?.metaChartData}
                            />
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </>
              ) : (
                <div className="template-flex">
                  <div className="skill-home scrollable">
                    <div className="auth-block">
                      <div className="auth-block-img">
                        <img src={unauthorizedIcon} />
                      </div>
                      <h3>
                        You are not authorized to view this Page or Page has
                        expired
                      </h3>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          window.location.href = "/dashboard/create";
                        }}
                      >
                        Go to dashboard
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </React.Fragment>
      )}
    </>
  );
};

export default ViewChartProcessDiscovery;